<template>
  <div class="">
      <v-layout wrap row justify-start  pa-4>
        <v-flex xs12>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Issue new voucher
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 px-1>
                  <v-text-field
										label="Token"
										readonly
										v-model="token"
										solo-inverted
										suffix="Voucher Token"
										:loading="loading"
										disabled
										light
										class="tokenField"
										color="white"
										background-color="primary"
									></v-text-field>
                </v-flex>
								
                
								<v-flex xs12 mb-3 v-if="lead">
									<v-card class="elevation-4 pa-4 text-xs-left">
										<v-layout row wrap>
											<v-flex xs12>
												<v-text-field
													label="Token"
													readonly
													v-model="orderKey"
													solo-inverted
													suffix="Order Token"
													:loading="loading"
													disabled
													light
													class="tokenField"
													color="white"
													background-color="primary"
												></v-text-field>
											</v-flex>
											<v-flex v-if="lead.name" xs6 md2>
												<div class="caption grey--text ">Client Name</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.name | truncate(15, (lead.name.length>15 ? '..': '')) }}</span>
													<span>{{ lead.name }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="lead.country" xs6 md2>
												<div class="caption grey--text ">Country</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.country | truncate(15, (lead.country.length>15 ? '..': '')) }}</span>
													<span>{{ lead.country }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="lead.phone_number_1" xs6 md2>
												<div class="caption grey--text ">Phone Number 1</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.phone_number_1 | truncate(15, (lead.phone_number_1.length>15 ? '..': '')) }}</span>
													<span>{{ lead.phone_number_1 }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="lead.import_date" xs6 md2>
												<div class="caption grey--text ">Date</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.import_date | truncate(15, (lead.import_date.length>15 ? '..': '')) }}</span>
													<span>{{ lead.import_date }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="lead.order_status" xs6 md2>
												<div class="caption grey--text ">Order Status</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.order_status  }}</span>
													<span>{{ lead.order_status }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex v-if="lead.total" xs6 md2>
												<div class="caption grey--text ">Order Total</div>
												<v-tooltip top>
													<span slot="activator">{{ lead.total  }}</span>
													<span>{{ lead.total }}</span>
												</v-tooltip>
											</v-flex>
											<v-flex xs12 px-1 v-if="lead" elevation-5 pa-3 my-3>
												<v-layout row wrap>
													<v-flex xs12 v-for="item in lead.order" :key="lead.key+item">
														<v-layout row wrap>
															<v-flex v-if="item.sku" xs6 md2>
																<div class="caption grey--text ">Product SKU</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.sku }}</span>
																	<span>{{ item.sku}}</span>
																</v-tooltip>
															</v-flex>
															<v-flex v-if="item.product" xs6 md2>
																<div class="caption grey--text ">Product Name</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.product | truncate(15, (item.product.length>15 ? '..': '')) }}</span>
																	<span>{{ item.product}}</span>
																</v-tooltip>
															</v-flex>
															<v-flex v-if="item.price" xs6 md2>
																<div class="caption grey--text ">Price Name</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.price | truncate(15, (item.price.length>15 ? '..': '')) }}</span>
																	<span>{{ item.price}}</span>
																</v-tooltip>
															</v-flex>
															<v-flex v-if="item.baseprice" xs6 md2>
																<div class="caption grey--text ">Base Price $</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.baseprice }}</span>
																	<span>{{ item.baseprice}}</span>
																</v-tooltip>
															</v-flex>
															<v-flex v-if="item.discount" xs6 md2>
																<div class="caption grey--text ">Discount</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.discount }}</span>
																	<span>{{ item.discount}}</span>
																</v-tooltip>
															</v-flex>
															<v-flex v-if="item.quantity" xs6 md2>
																<div class="caption grey--text ">Quantity</div>
																<v-tooltip top>
																	<span slot="activator">{{ item.quantity }}</span>
																	<span>{{ item.quantity}}</span>
																</v-tooltip>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>
									</v-card>
								</v-flex>
								<v-flex xs12 md6 pa-1>
                  <v-text-field
										label="Issue Date"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="issue_date"
									></v-text-field>
                </v-flex>
                
								<v-flex xs12 md6 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md6 px-1 mt-1>
									<v-menu
										v-model="tsd"
										:close-on-content-click="false"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<template slot="activator">
											<v-text-field
												v-model="expiry_date"
												label="Expiry Date"
												append-icon="event"
												readonly
												clearable
												solo
												hide-details
												:loading="loading"
											></v-text-field>
										</template>
										<v-date-picker v-model="expiry_date" @input="tsd = false"></v-date-picker>
									</v-menu>
								</v-flex>
								
								<v-flex xs12 md6 pa-1>
									<v-text-field
										label="Voucher amount in $ (only number)"
										solo
										hide-details
										@keypress="isNumber($event)"
										type="number"
                    :loading="loading"
										v-model="voucher_amount"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-autocomplete
										:items="types"
										v-model="type"
										label="Select a type"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
										:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
										@click:append-outer="addSourceD = true"
									></v-autocomplete>
									<v-dialog v-model="addSourceD" persistent max-width="290">
										<v-card>
											<v-card-title class="headline">You want to add a Voucher Type?</v-card-title>
											<v-card-text>
												<v-layout row wrap>
													<v-flex xs12>
														<v-text-field
															label="Voucher"
															required
															v-model="newSource"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="red darken-1" flat @click="addSourceD = false">Cancel</v-btn>
												<v-btn :disabled="!newSource" color="green darken-1" flat @click="addSource()">add</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Notes"
										v-model="note"
										solo
									></v-textarea>
              	</v-flex>
								
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="issueVoucher()" :loading="loading" color="primary" dark>
                issue {{ token }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
			<!-- <v-dialog fullscreen v-model="dialogs.qr" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Please Scan QR</v-card-title>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12>
                <img :src="qrCode">
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="primary" @click="checkWA()" dark>Scan Then Click here</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.qr = null">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
export default {
  data(){
    return {
			loading: false,
			tokenLoading: false,
			lead:null,
			token: false,
			orderKey:null,
			tsd:false,
			expiry_date:null,
			issue_date:null,
			phone_number_1:null,
			client_name:null,
			voucher_amount:null,
			note:null,
			addSourceD:null,
			newSource:null,
			type:null,
			dialogs:{qr:false},
			types:[],
    }
  },
  methods: {
		async addSource() {
			if(!this.newSource) return
			await db.ref(`voucherstypes`).push(this.newSource)
			this.addSourceD = false
			this.getSources()
		},
		async getSources(){
			let a = await db.ref(`voucherstypes`).once('value').then(x=>x.val())
			for (const key in a) {
				if (a.hasOwnProperty(key)) {
					const b = a[key];
					this.types.push(b)
				}
			}
		},
		isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path)
		},
		async issueVoucher(){
			let v = {
				name:this.lead.name,
				order:this.orderKey,
				issue_date:this.issue_date,
				expiry_date:this.expiry_date,
				agent:this.$props.userName,
				phone_number_1:this.lead.phone_number_1,
				uid:this.token,
				active:true,
				amount:parseFloat(this.voucher_amount),
				note:this.note,
				type:this.type
			}
			await db.ref(`vouchers/${this.token}`).update(v)
			this.sendWANotification(this.lead, v)
			this.goTo('/vouchers')
			console.log(v)
		},
		async sendWANotification(lead, v){
      //this.selectForEdit(lead)
      let msgSettings = {
        arMale: {
					name:``,
					amount:``,
					expiry_date:``,
					uid:``,
          message: function(){ 
            return `عميلنا العزيز السيد ${this.name},\n\n`+
            `نود اعلامكم بأنه تم اضافة ${this.amount} الى محفظتك\n`+
            `صالحة لتاريخ ${this.expiry_date} لاستخدامها في عملية الشراء القادمة من المتجر\n`+
            `رقم القسيمة ${this.uid}.\n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        arFemale:{
					name:``,
					amount:``,
					expiry_date:``,
					uid:``,
          message: function(){ 
            return `عميلتنا العزيزة السيدة ${this.name},\n\n`+
            `نود اعلامكم بأنه تم اضافة ${this.amount} الى محفظتك\n`+
            `صالحة لتاريخ ${this.expiry_date} لاستخدامها في عملية الشراء القادمة من المتجر\n`+
            `رقم القسيمة ${this.uid}.\n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        enMale:{
					name:``,
					amount:``,
					expiry_date:``,
					uid:``,
          message:function(){
            return `Dear valued customer Mr. ${this.name},\n` +
            `We would like to inform you that a ${this.amount} added to your wallet\n` +
            `to be used for shopping from our store until ${this.expiry_date}\n` +
            `This is your Voucher code ${this.uid}\n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n`
          }
        },
        enFemale:{
          name:``,
          amount:``,
					expiry_date:``,
					uid:``,
          message:function(){
            return `Dear valued customer Ms. ${this.name},\n` +
						`We would like to inform you that a ${this.amount} added to your wallet\n` +
            `to be used for shopping from our store until ${this.expiry_date}\n` +
            `This is your Voucher code ${this.uid}\n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n`
          }
        },
      }  
      if(true
      ){
				let msgObj = msgSettings[lead.language + lead.gender]
				msgObj.name = lead.name
				msgObj.amount = v.amount
				msgObj.expiry_date = v.expiry_date
				msgObj.uid = v.uid
				console.log(msgObj.message())
				let myNumber = '96262000040' //'96262000045'
				if(lead.company_code && lead.company_code.toUpperCase() == 'ASHYAAT JO') {
					myNumber = '962796041616'
				} else if(lead.company_code && lead.company_code.toUpperCase() == 'TELEMARKETING') {
					myNumber = '96262008683'
				}
				// let post = {
				// 	number:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
				// 	message:msgObj.message(),
				// }
				// const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
				// const headers = {
				// 	'Accept': 'application/json'
				// }
				// let send = await axios.post(`// WA API //`, post, {headers:headers}).then(x=>x.data)
				// if(send.success) {
				// 	this.sending = false
				// 	this.sMessage = null
				// 	this.file = null
				// 	this.imgURL = null
				// 	this.imgURLExt = null
				// 	this.loading = false
				// 	this.nNumber = null
				// 	this.dialog = false
				// } else if(send.qr){
				// 	this.dialogs.qr = true
				// 	this.loading = false
				// 	this.qrCode = send.qr
				// 	this.$emit('snackbarNotification', `Please scan ${send.number} QR code`, 'error')
				// } else {
				// 	this.$emit('snackbarNotification', `${send.number?send.number:''} ${send.message}`, 'error')
				// }
				// let n = await db.ref(`settings/wa/${myNumber}`)
				// .once('value')
				// .then(x=>x.val());
				// axios.get(`${n.instance}status?token=${n.token}`)
				// .then(resp => {
				// 	if (resp.data.qrCode) {
				// 		this.dialogs.qr = true
				// 		this.qrCode = resp.data.qrCode
				// 		this.$emit('snackbarNotification', `Please scan ${myNumber} QR code`, 'success')
				// 	} else if(resp.data.accountStatus == 'authenticated'){
				// 		this.dialogs.qr = false
				// 		this.qrCode = null
				// 		this.$emit('snackbarNotification', `Ready to send`, 'success');
				// 		var headers = {
				// 			'Accept': 'application/json'
				// 		}
				// 		let post = {
				// 			phone:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
				// 			body:msgObj.message()
				// 		}
				// 		axios.post(`${n.instance}sendMessage?token=${n.token}`, post, {headers: headers})
				// 		.then(resp=>{
				// 			if (resp.data.sent) {
				// 				this.$emit('snackbarNotification', `Customer Notified on Confirmation in WA`, 'success')
				// 			}
				// 		})
				// 	} else {
				// 		this.loading = false
				// 		this.$emit('snackbarNotification', `Please Login to chat-api.com and click USE HERE`, 'success')
				// 		setTimeout(x=>{
				// 			window.open('https://app.chat-api.com/')
				// 		}, 2000)
				// 	}
				// })
      }
    },
		genToken() {
      this.tokenLoading = true
      let vtoken = `ASH_V_${randomString(8, 'aA#')}`
      this.token = vtoken
      this.tokenLoading = false
      return vtoken
    },
    async getOrder(token){
			this.loading = true
			// this.lead = await db.ref(`leads/${token}`).once('value').then(x=>x.val())
			this.lead = await store.collection(`leads`).doc(token).get().then(x=>x.data())
			this.lead.key = token
			this.client_name = this.lead.name
			this.phone_number_1 = this.lead.phone_number_1
			this.lead.total = this.lead.order.map(x=>x.baseprice).reduce((a,b)=>parseFloat(a)+parseFloat(b))
			console.log(this.lead)
      this.loading = false
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
		},
  },
  props:{
    userName:{
			required:true
		},
		userRole:{
			required:true
		}
  },
  computed:{
    
  },
  async created(){
		this.genToken()
		this.orderKey = this.$route.params.token
		this.getOrder(this.orderKey)
		this.issue_date = getCDate()
		this.getSources()

		
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
